// Shared helpers for the signup success screens: masking the address we echo
// back to the user, and resolving a webmail "open my inbox" deep link when the
// domain is a provider we recognize.

export const maskEmail = (email) => {
  if (typeof email !== "string") return "";
  const atIndex = email.lastIndexOf("@");
  if (atIndex <= 0) return "";
  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  const chars = Array.from(local);
  if (chars.length <= 2) return `${"*".repeat(chars.length)}${domain}`;
  return `${chars[0]}***${chars[chars.length - 1]}${domain}`;
};

// Consumer webmail domains → their inbox URL. Business/custom domains aren't
// here on purpose: we can't guess their webmail, so the "Open My Email" button
// is simply hidden for them (see getEmailProviderInbox returning null).
const EMAIL_PROVIDER_INBOX = {
  "gmail.com": "https://mail.google.com/mail/u/0/",
  "googlemail.com": "https://mail.google.com/mail/u/0/",
  "outlook.com": "https://outlook.live.com/mail/",
  "hotmail.com": "https://outlook.live.com/mail/",
  "hotmail.co.uk": "https://outlook.live.com/mail/",
  "live.com": "https://outlook.live.com/mail/",
  "msn.com": "https://outlook.live.com/mail/",
  "yahoo.com": "https://mail.yahoo.com/",
  "yahoo.co.uk": "https://mail.yahoo.com/",
  "ymail.com": "https://mail.yahoo.com/",
  "aol.com": "https://mail.aol.com/",
  "icloud.com": "https://www.icloud.com/mail",
  "me.com": "https://www.icloud.com/mail",
  "mac.com": "https://www.icloud.com/mail",
  "proton.me": "https://mail.proton.me/u/0/inbox",
  "protonmail.com": "https://mail.proton.me/u/0/inbox",
};

/**
 * Return the webmail inbox URL for an email's domain, or null when we don't
 * recognize the provider. Callers show the "Open My Email" button only when
 * this is non-null.
 */
export const getEmailProviderInbox = (email) => {
  if (typeof email !== "string") return null;
  const atIndex = email.lastIndexOf("@");
  if (atIndex < 0) return null;
  const domain = email.slice(atIndex + 1).trim().toLowerCase();
  return EMAIL_PROVIDER_INBOX[domain] || null;
};
